import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, B1, BlueButton } from '../../StyledComponents';
import { navigate } from '@reach/router';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EnhancedBadge from '../../../assets/v2/DigitalSignage/banner.svg';
import ValidatedBadge from '../../../assets/v2/Hardware/validated-straight.svg';
// import { BottomBanner } from '../BottomBanner';
import { StaticQuery, graphql, Link } from 'gatsby';
// import GatsbyImage from 'gatsby-image';
// import OurPartners from '../OurPartnersContactUs';
import Heart from '../../../assets/v2/Hardware/Heart.svg';
import HeartFilled from '../../../assets/v2/Hardware/HeartFilled.svg';
import { cleanupSlugs } from '../../../globalFunctions';

const LazyImg = styled(LazyLoadImage)`
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
`;

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #ffffff;
`;
const SecondSection = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f9f9fb;
`;

const ManageHeading = styled.div`
  text-align: center;
  color: #7a55a5;
  margin-top: 5rem;
  @media (max-width: 520px) {
    margin-top: 1rem;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding-top: 2rem;
  grid-gap: 1rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 100%;
  /* margin-right: -3rem;
  margin-left: -3rem; */
  justify-items: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }
  @media (max-width: 768px) {
    justify-items: center;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    margin-top: -1rem;
    padding-bottom: 2rem;
  }
`;

const GridContainerEnhanced = styled(GridContainer)`
  /* grid-template-columns: repeat(4, 1fr); */
  /* width: 85%; */
`;

const HoveringLayer = styled.div`
  grid-column: span 1;
  min-width: 250px;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  background: #725cbd;
  width: 100%;
  position: absolute;
  top: -2rem;
  z-index: 10;
  display: grid;
  cursor: pointer;
  height: 100%;
  opacity: 0.95;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 400px) {
    min-width: unset;
  }
`;

const HoveringLayerValidated = styled(HoveringLayer)`
  background: #7ec79c;
`;
const HoveringContent = styled.div`
  display: grid;
  justify-content: center;
  padding: 4rem;
  align-content: center;
  @media (max-width: 520px) {
    padding: 2rem;
  }
`;

const HoveringPoint = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  color: #ffffff;
  padding-bottom: 0.5rem;
`;
const GridItem = styled.div`
  grid-column: span 1;
  max-width: 260px;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  transition: transform 0.3s ease-in;
  width: 100%;
  /* :hover {
    transform: scale(1.05);
    opacity: 0.8;
  } */
  position: relative;
  background: white;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  /* margin-left: 12%; */
  cursor: pointer;
  position: relative;
  @media (max-width: 768px) {
    flex: 0 0 calc(100%);
    /* display: grid; */
    justify-items: center;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
    max-width: unset;
    width: 80%;
  }
  @media (max-width: 400px) {
    min-width: unset;
    margin-left: 0;
  }
`;

const imageStyle = {
  maxWidth: '100%',
  maxHeight: '15rem',
  alignSelf: 'center',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
  height: 12rem;
  padding: 2rem 1rem;

  @media (max-width: 768px) {
    min-width: 18rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    height: 15rem;
    min-width: unset;
    max-width: 20rem;
  }
`;

const GridTop = styled.div`
  min-height: 3rem;
  display: flex;
  cursor: default !important;
`;
const HeartContainer = styled.div`
  margin-left: 1rem;
  padding-top: 1.5rem;
  width: 5rem;
  cursor: pointer !important;
`;
const GridBottom = styled.div`
  min-height: 3rem;
  background: #ffffff;
  padding: 1rem;
  width: 100%;

  display: grid;
  justify-content: center;
  align-items: center;
`;

const GridBottomText = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000f16;
  text-align: start;
`;
const imageStyleTop = {
  width: '100%',
};

const ImgContainerTop = styled.div`
  display: grid;
  width: 100%;
  justify-content: end;
  padding-top: 1rem;
  grid-column: span 1;
  right: 0;
`;
const SectionHeading = styled(H1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
`;
const SectionSubHeading = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  color: #7f8495;
  width: 40rem;
  font-weight: normal;
  @media (max-width: 600px) {
    width: fit-content;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 24px;
  padding-bottom: 3rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const BottomImageContainer = styled.div`
  padding: 0.5rem 0;
  border-bottom: solid 1px #e8e8e8;
  display: grid;
  justify-content: center;
`;
const BottomImg = styled(LazyLoadImage)`
  max-width: 8rem;
`;

const BlueButtonNew = styled(BlueButton)`
  color: #ffffff;
  border-radius: 34px;
`;
export default class extends React.Component<any, any> {
  state = {
    hover: -1,
    wishArray: [],
  };
  componentDidMount() {
    this.getWishList();
    this.setFilters();
  }

  componentDidUpdate() {
    this.setFilters();
  }

  handleWishList = (name: any) => {
    if (this.state.wishArray.some((item1: any) => item1 === name)) {
      const newlist = this.state.wishArray.filter((x) => x !== name);
      this.setState({ wishArray: [...newlist] }, () => {
        localStorage.setItem('wishlist', JSON.stringify(this.state.wishArray));
        this.props.updateWishList();
        this.getWishList();
        this.setFilters();
      });
    } else {
      this.setState({ wishArray: [...this.state.wishArray, name] }, () => {
        localStorage.setItem('wishlist', JSON.stringify(this.state.wishArray));
        this.props.updateWishList();
        this.getWishList();
        this.setFilters();
      });
    }
  };

  setFilters = () => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const wishArr = this.state?.wishArray?.toString().replace(/,/g, '~');
    url.searchParams.set('wishlist', wishArr);
    window.history.replaceState(null, '', url.search);
  };

  getWishList = () => {
    let storedList = localStorage.getItem('wishlist');
    storedList = storedList === null ? [] : JSON.parse(storedList);
    this.setState({
      wishArray: storedList,
    });
  };
  handleHover = (index: number) => {
    this.setState({
      hover: index,
    });
  };
  handleHoverExit = () => {
    this.setState({
      hover: -1,
    });
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          {
            esperEnhancedAndroid: allAirtable(
              filter: {
                data: { isEAA: { eq: true }, Published: { eq: true } }
                table: { eq: "Hardwares" }
              }
              limit: 5
            ) {
              nodes {
                table
                id
                recordId
                data {
                  Name
                  OS {
                    data {
                      Name
                    }
                  }
                  Slugs
                  Model {
                    id
                    data {
                      Name
                    }
                  }
                  BrandLogo {
                    data {
                      Notes {
                        url
                      }
                    }
                  }
                  Image {
                    url
                  }
                }
              }
            }
            esperRecommended: allAirtable(
              filter: {
                data: { isEAA: { ne: true }, Published: { eq: true } }
                table: { eq: "Hardwares" }
              }
              limit: 5
            ) {
              nodes {
                table
                id
                recordId
                data {
                  Name
                  OS {
                    data {
                      Name
                    }
                  }
                  Slugs
                  Model {
                    id
                    data {
                      Name
                    }
                  }
                  BrandLogo {
                    data {
                      Notes {
                        url
                      }
                    }
                  }
                  Image {
                    url
                  }
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <div>
            <Section id="enhanced-devices">
              <ManageHeading>
                <SectionHeading>Esper Enhanced Android Devices</SectionHeading>
                {/* <SectionSubHeading style={{ color: '#7f8495' }}>
                  Esper Enhanced Android Devices are devices that are shipped
                  with a customized Android OS for enterprise devices delivering
                  improved performance, faster deployement, and superior
                  debugging. Esper tailors the OS to your specific needs,
                  including in-ROM apps and specific peripheral support.
                </SectionSubHeading> */}
              </ManageHeading>
              <GridContainerEnhanced>
                {data.esperEnhancedAndroid.nodes.map(
                  (item: any, index: number) => (
                    <GridItem
                      key={item.recordId + index}
                      onMouseEnter={() => this.handleHover(index)}
                      onMouseLeave={this.handleHoverExit}
                      style={{
                        borderBottom: '5px solid #725cbd',
                        borderRadius: '4px',
                      }}
                    >
                      {/* {this.state.hover === index && (
                        <HoveringLayer>
                          <HoveringContent>
                            {item.node.tags
                              .slice(0, 4)
                              .map((tagItem: any, key: number) => (
                                <HoveringPoint
                                  style={key > 4 ? { display: 'none' } : {}}
                                  key={tagItem}
                                >
                                  {tagItem}
                                </HoveringPoint>
                              ))}
                          </HoveringContent>
                        </HoveringLayer>
                      )} */}
                      <GridTop>
                        <HeartContainer
                          onClick={() => this.handleWishList(item?.data?.Name)}
                        >
                          {this.state.wishArray.some(
                            (item1: any) => item1 === item?.data?.Name
                          ) ? (
                            <img src={HeartFilled} />
                          ) : (
                            <img src={Heart} />
                          )}
                        </HeartContainer>
                        <ImgContainerTop>
                          <LazyLoadImage
                            alt={'Esper Enhanced'}
                            src={EnhancedBadge}
                            style={imageStyleTop}
                          />
                        </ImgContainerTop>
                      </GridTop>
                      {/* // TODO */}
                      <Link to={`/hardware/${cleanupSlugs(item.data.Slugs)}`}>
                        {/* <Link to={`/${item.node.slug}`}> */}
                        <ImgContainer>
                          <LazyImg
                            alt={item.data.Name}
                            src={item.data.Image?.[0]?.url}
                            style={imageStyle}
                          />
                        </ImgContainer>
                        <BottomImageContainer>
                          <BottomImg
                            alt={'brand'}
                            src={
                              item.data.BrandLogo?.[0]?.data?.Notes?.[0]?.url
                            }
                            // style={imageStyleTop}
                          />
                        </BottomImageContainer>
                        <GridBottom>
                          <GridBottomText>{item.data?.Name}</GridBottomText>
                        </GridBottom>
                      </Link>
                    </GridItem>
                  )
                )}
              </GridContainerEnhanced>
              <BlueButtonWrapper>
                <BlueButtonNew
                  onClick={() =>
                    navigate('/hardware/product-list/esper-enhanced')
                  }
                >
                  Explore more
                </BlueButtonNew>
              </BlueButtonWrapper>
            </Section>

            <SecondSection id="validated-devices">
              <ManageHeading>
                <SectionHeading> Esper Validated Devices</SectionHeading>
                <SectionSubHeading>
                  Esper Validated Devices are off-the-shelf devices from leading
                  hardware vendors that have been validated by the Esper device
                  team and existing customers for enterprise use cases and
                  reliability. Devices work seamlessly with Esper-based
                  enterprise solutions.
                </SectionSubHeading>
              </ManageHeading>
              <GridContainer>
                {data.esperRecommended.nodes.map((item: any, index: number) => (
                  <GridItem
                    key={item.recordId + index}
                    onMouseEnter={() => this.handleHover(index)}
                    onMouseLeave={this.handleHoverExit}
                    style={{
                      borderBottom: '5px solid #725cbd',
                      borderRadius: '4px',
                    }}
                  >
                    {/* {this.state.hover === index && (
                        <HoveringLayerValidated>
                          <HoveringContent>
                            {item.node.tags
                              .slice(0, 4)
                              .map((tagItem: any, key: number) => (
                                <HoveringPoint
                                  style={key > 4 ? { display: 'none' } : {}}
                                  key={tagItem}
                                >
                                  {tagItem}
                                </HoveringPoint>
                              ))}
                          </HoveringContent>
                        </HoveringLayerValidated>
                      )} */}

                    <GridTop>
                      {' '}
                      <HeartContainer
                        onClick={() => this.handleWishList(item?.data?.Name)}
                      >
                        {this.state.wishArray.some(
                          (item1: any) => item1 === item?.data?.Name
                        ) ? (
                          <img src={HeartFilled} />
                        ) : (
                          <img src={Heart} />
                        )}
                      </HeartContainer>
                      <ImgContainerTop>
                        <LazyLoadImage
                          alt={'Esper Validated'}
                          src={ValidatedBadge}
                          style={imageStyleTop}
                        />
                      </ImgContainerTop>
                    </GridTop>
                    {/* <Link to={`/${item.node.slug}`}> */}
                    <Link to={`/hardware/${cleanupSlugs(item.data.Slugs)}`}>
                      <ImgContainer>
                        <LazyImg
                          alt={item.data.Name}
                          src={item.data.Image?.[0]?.url}
                          style={imageStyle}
                        />
                      </ImgContainer>
                      <BottomImageContainer>
                        <BottomImg
                          alt={'brand'}
                          src={item.data.BrandLogo?.[0]?.data?.Notes?.[0]?.url}
                          // style={imageStyleTop}
                        />
                      </BottomImageContainer>
                      <GridBottom>
                        <GridBottomText>{item.data?.Name}</GridBottomText>
                      </GridBottom>
                    </Link>
                  </GridItem>
                ))}
              </GridContainer>
              <BlueButtonWrapper>
                <BlueButtonNew
                  onClick={() =>
                    navigate('/hardware/product-list/esper-validated')
                  }
                  style={{ background: '#7ec79c' }}
                >
                  Explore more
                </BlueButtonNew>
              </BlueButtonWrapper>
            </SecondSection>
          </div>
        )}
      />
    );
  }
}
